<template>
  <div>
    <router-view :id="id"></router-view>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import Objects from '@/services/Objects.js'

export default {
  name: 'Vessel',
  props: {
    id: String
  },
  data() {
    return {
      vessel: ''
    }
  },
  created() {
    this.getVessel()
  },
  methods: {
    getVessel() {
      ApiService.get(Objects.Vessel, this.id).then(response => {
        this.vessel = response.data
        this.$store.dispatch('setPageTitle', this.vessel.name)
        document.title = this.vessel.name
      })
    }
  }
}
</script>

<style scoped></style>
